import cn from "classnames"
import { Link } from "react-router-dom"

import styles from "./styles.module.scss"

import { Img, Text } from "ui-kit/components-branded/index"
import { APP_PAGE_URL } from "utils/env-management"

interface Props {
    className?: string
    isHoverable?: boolean
}

export function GiftLink({ className, isHoverable = false }: Props) {
    return (
        <Link to={`${APP_PAGE_URL}/gift`} className={cn(className, styles.giftLink)}>
            <Img src="gift.png" />
            <span
                data-testid="gift-link-target"
                className={cn({ [styles.isHoverable]: isHoverable })}
            >
                <Text isAccent>Сертификаты</Text>
            </span>
        </Link>
    )
}
